import React from 'react';

import UnlinkIcon from '@usas/ui-web/components/icons/UnlinkIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const TableRow = ({ preCompLocation, onDelete }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}><span className='hidden-xs'>{preCompLocation.preCompLocationName}</span>&nbsp;
      <button
        type="button"
        className={global.IconButton}
        onClick={(e) => onDelete(e, preCompLocation.preCompLocationClubId)}>
        <UnlinkIcon />
      </button>
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 visible-xs'].join(' ')}>Location Name</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 visible-xs'].join(' ')}>{preCompLocation.preCompLocationName || <span>&nbsp;</span>}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6'].join(' ')}>Address</div>
        <div className={[global.SmallTableRowData, 'col-xs-6'].join(' ')}>{preCompLocation.preCompLocationAddress || <span>&nbsp;</span>}</div>
      </div>
    </div>
  </div>
);

const ClubPreCompGridSmallWrite = ({ data, isLoading, onDelete }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>Loading...</div>
          </div>
        </div>
      )
      : data.length > 0
        ? data.map((preCompetitiveLocation, i) => <TableRow key={i} preCompLocation={preCompetitiveLocation} onDelete={onDelete} />)
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Pre-Competitive Programs</div>
            </div>
          </div>
        )}
  </div>
);

export default ClubPreCompGridSmallWrite;